import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private activeRequests = 0;
  private _isLoading = signal(false);
  public loaderEnabled = true;

  constructor() {}

  showLoader(): void {
    this.activeRequests++;
    if (this.activeRequests === 1) {
      this.isLoading = true;
    }
  }

  hideLoader(): void {
    this.activeRequests--;
    if (this.activeRequests <= 0) {
      this.activeRequests = 0;
      this.isLoading = false;
    }
  }

  set isLoading(value: boolean) {
    this._isLoading.set(value);
  }

  get isLoading(): boolean {
    return this._isLoading();
  }
}
